// extracted by mini-css-extract-plugin
module.exports = {"editMatch":"MatchEdit_editMatch__3kCyT","errorMsg":"MatchEdit_errorMsg__c4Tzl"};